import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventsService {
  private evento: EventEmitter<any> = new EventEmitter();
  constructor() { }

  emitEvento(payload) {
    this.evento.emit(payload);
  }

  getEvento() {
    return this.evento;
    // evento.subscribe((payload) => {});
  }

}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/events/events.service.ts